<template>
  <div>
    <alert
      v-if="alertVisible"
      :message="alertMessage"
      :type="alertType">
    </alert>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="breadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                {{ $t('user.title') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="userTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="name"
                :label="$t('user.name')"
                :formatter="formatName"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="enabled"
                :label="$t('user.status')"
                :formatter="formatStatus"
                header-class="table-component__medium__width__column"
                cell-class="text-center">
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.enabled"
                    :id="row"
                    v-on:click="onUpdate(row)"
                    :icon="icon.pencil"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.pencil"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
    <nightscout-passphrase-modal
      v-if="showModal"
      v-on:cancel="showModal = false"
      v-on:ok="updatePasshprase"/>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import pagination from '@/components/shared/table/pagination';
import {mapActions, mapGetters} from 'vuex';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faPencilAlt} from '@fortawesome/pro-regular-svg-icons';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import Alert from '@/components/shared/alert/Alert';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import BtnPill from '@/components/shared/buttons/BtnPill';
import NightscoutPassphraseModal from 'BRAND/components/nightscout/NightscoutPassphraseModal';

export default {
  components: {
    NightscoutPassphraseModal,
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    OkCancelModal,
    Alert,
    BtnPill
  },
  data () {
    return {
      alertVisible: false,
      alertMessage: '',
      alertType: '',
      icon: {
        pencil: faPencilAlt
      },
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      breadcrumb: [
        {name: 'Nightscout', disabled: true}
      ],
      showModal: false,
      updatingUserId: null
    };
  },
  watch: {
    getUsers: {
      handler: function () {
        this.$refs.userTable.refresh();
      }
    }
  },
  created () {
    this.retrieveUsers({context: this});
  },
  computed: {
    ...mapGetters([
      'getUsers'
    ])
  },
  methods: {
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.getUsers,
        this.tableState,
        ['name'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    onUpdate (user) {
      this.updatingUserId = user.id;
      this.showModal = true;
    },
    updatePasshprase (passphrase) {
      this.showModal = false;
      const promise = this.updateNightscoutUserPassphrase({ context: this, passphrase: passphrase, id: this.updatingUserId });
      promise.then(
        () => showAlert(this, this.$t('xugarhero.changePassphrase.success'), 'success'),
        (error) => {
          if (error.status === 409) {
            showAlert(this, this.$t('xugarhero.changePassphrase.passphraseInUse'), 'error');
          } else {
            showAlert(this, 'Error', 'error');
          }
        });
    },
    formatName (value, rowProperties) {
      return rowProperties.name + (rowProperties.admin === true ? ' (admin)' : '');
    },
    formatStatus (value, rowProperties) {
      return rowProperties.enabled ? this.$t('user.enabled') : this.$t('user.disabled');
    },
    ...mapActions([
      'retrieveUsers',
      'updateNightscoutUserPassphrase'
    ])
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};
</script>

<style lang="scss" scoped>
  @import "../stylesheets/variables.scss";

  #header {
    display: inline-block;
    width: 100%;
    line-height: 1rem;
  }
  .header-title {
    float: left;
  }

  .table-iconset-icon {
    cursor: pointer;
  }

  .table-icon-disabled {
    opacity: 0.4;
    margin: 0 0.5em;
    cursor: default;
  }
</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/layouts/NightscoutUserList.vue